module.exports = __webpack_public_path__ + "static/media/rewards.c0a9c2cf.png";